<template>
  <div class="row">

    <div class="col-md-12">
      <create-goal-form @on-submit="onCreateGoalSubmit"></create-goal-form>
    </div>
  </div>
</template>
<script>
  import CreateGoalForm from './Forms/CreateGoalForm.vue'

  export default {
    components: {
      CreateGoalForm
    },
    data () {
      return {
        createTransactionModel: {}
      }
    },
    methods: {
      onCreateGoalSubmit (model, isValid, validateObject) {
        model.saveGoalButtonText = 'Saving Goal ...'
        this.$http.post('/goals', {
          amount: model.targetAmount * 100,
          description: model.description,
          due_date: model.goalDueDate,
          start_date: model.goalStartDate,
          saved: model.savedAmount * 100,
          goals_status_id: 1,
        })
        .then(response=>{
          if(response.data.created_at){

            model.targetAmount = ''
            model.description = ''
            model.goalDueDate = ''
            model.goalStartDate = ''
            model.savedAmount = ''
            model.saveGoalButtonText = 'Goal Saved. Save Another'
            
            this.$nextTick(function () {
              validateObject.reset()
            })
          }
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      }
    }
  }
</script>
<style>
</style>
